
export default {
    getName: (state) => state.name,
    getNextSeqCode: (state) => state.nextSeqCode,
    getActivityTypes: (state) => state.activityTypes,
}